import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['bearableDegreeField', 'bearableDegreeWarning', 'submit']

  connect() {
    if (this.hasBearableDegreeFieldTarget) {
      this.toggleBearableDegree()
    }
  }

  toggleBearableDegree() {
    const selectedInput = this.bearableDegreeFieldTarget.querySelector('input:checked')
    const isZero = selectedInput?.value === 'none'

    this.bearableDegreeWarningTarget.classList.toggle('d-none', !isZero)

    if (this.hasSubmitTarget) {
      this.submitTarget.disabled = isZero
    }
  }
}
